var map = {
	"./popular-canterano.json": 7390,
	"./popular-darsena-demo.json": 1702,
	"./popular-darsena.json": 7702,
	"./popular-payment-system.json": 9255,
	"./popular-yoga-demo.json": 8571,
	"./popular-yoga.json": 3530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2234;